import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getCategoryImage } from '../config/categoryImages';
import {
  pageMeta,
  buildBreadcrumbJsonLd,
  buildItemListJsonLd,
} from '../config/seo';
import OptimizedImage from '../components/OptimizedImage';
import SeoHead from '../components/SeoHead';
import './HubLayout.css';

function CategoryCardVisual({ hub, slug }) {
  const [failed, setFailed] = useState(false);
  const src = getCategoryImage(hub, slug);

  if (!src || failed) {
    return (
      <div
        className="category-card__visual category-card__visual--fallback"
        data-variant={slug}
        aria-hidden
      />
    );
  }

  return (
    <div className="category-card__visual">
      <OptimizedImage
        src={src}
        alt=""
        className="category-card__img"
        loading="lazy"
        decoding="async"
        onError={() => setFailed(true)}
      />
    </div>
  );
}

export default function HubLayout({ title, subtitle, categories, basePath }) {
  const hub = basePath === '/sekerlik' ? 'sekerlik' : 'davetiyeler';
  const meta = hub === 'sekerlik' ? pageMeta.sekerlik : pageMeta.davetiyeler;
  const hubLabel = hub === 'sekerlik' ? 'Şekerlik' : 'Davetiyeler';

  const jsonLd = [
    buildBreadcrumbJsonLd([
      { name: 'Anasayfa', path: '/' },
      { name: hubLabel, path: basePath },
    ]),
    buildItemListJsonLd(
      title,
      categories.map((cat) => ({
        name: cat.title,
        path: `${basePath}/${cat.slug}`,
      }))
    ),
  ];

  return (
    <main className="page hub-page">
      <SeoHead
        title={meta.title}
        description={meta.description}
        path={meta.path}
        jsonLd={jsonLd}
      />
      <header className="page-hero page-hero--compact">
        <div className="page-hero__inner">
          <h1 className="page-hero__title">{title}</h1>
          {subtitle && <p className="page-hero__lead">{subtitle}</p>}
        </div>
      </header>
      <section className="category-grid section">
        <div className="category-grid__inner">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`${basePath}/${cat.slug}`}
              className="category-card"
            >
              <CategoryCardVisual hub={hub} slug={cat.slug} />
              <div className="category-card__body">
                <h2 className="category-card__title">{cat.shortTitle}</h2>
                <p className="category-card__desc">{cat.description}</p>
                <span className="category-card__cta">İncele →</span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
}
